/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';

// material
import {Control, Controls, Link, ListTable} from '@insticator/insticator-ui'; // iui-material

// utils

// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/commenting/statistics/statistics_styles';

/* ========== ~~~~~~~~~~ COMMENTING STATISTICS ~~~~~~~~~~ ========== */
class Statistics extends Component {
    constructor(props){
        super(props);
        this.data = {};
        this.state= {
            intervalSelected: `day`,
            increment: 0 // called skip in the API
        }
    }

    componentDidMount(){
        if (this.props.commentingUnitUUID) {
            this.fetchStatistics(this.state.increment, null, this.state.intervalSelected);
        }
    }
    // componentDidUpdate(prevProps, prevState){
    //     // if ((prevState.intervalSelected !== this.state.intervalSelected) && this.props.commentingUnitUUID) {
    //     //     if (prevState.intervalSelected !== this.state.intervalSelected) {
    //     //         this.setState({ increment: 0 });
    //     //         this.fetchStatistics(0, null);
    //     //     } else {
    //     //         this.fetchStatistics(this.state.increment, this.props.statistics);
    //     //     }
    //     // }
    // }
    //fetch data call
    fetchStatistics = (increment, currentStats, interval) => this.props.loadCommentingStatisticsTableData(this.props.commentingUnitUUID, interval.toUpperCase(), increment, currentStats);

    changeInterval = (value) => {
        this.setState({ intervalSelected: value, increment: 0 }, this.fetchStatistics(0, null, value));
    }

    changeIncrement = () => {
        const increment = this.state.increment + 10;
        this.setState({ increment }, this.fetchStatistics(increment, this.props.statistics, this.state.intervalSelected));
    }

    exportAllProps = () => ({
        apiCall: () => this.props.exportStatisticsData(this.props.commentingUnitUUID, this.state.intervalSelected),
        fileName: 'CommentStatistics',
        excludedColumns: ['revenue']
    });

    render() {
        return(
            <div className={`statistics ${this.props.classes.statistics}`}>
                <Controls>
                    <Control selected={this.state.intervalSelected === 'day'} text={`Day`} value={`day`} handleSelect={this.changeInterval} />
                    <Control selected={this.state.intervalSelected === 'month'} text={`Month`} value={`month`} handleSelect={this.changeInterval} />
                    <Control selected={this.state.intervalSelected === 'year'} text={`Year`} value={`year`} handleSelect={this.changeInterval} />
                </Controls>
                <ListTable
                    name={`statistics`}
                    size={`full`}
                    variant={'nowrap'}
                    columnHeads={{ dateRange: 'Date Range', viewCount: 'Views', commentCount: 'Comments', promoTokenCount: 'Promo Tokens', otherTokenCount: 'Other Tokens'}}
                    data={!this.props.statistics ? [] : this.props.statistics}
                    dataType={`commentstatistics`}
                    clickableRow={false}
                    loading={this.props.fetchingCommentingStatistics}
                    moreDetails={false}
                    exportAll={this.exportAllProps()}
                    />
                    {this.props.hasMoreData && <Link text={`SHOW MORE`} color={`grey`} handleClick={this.changeIncrement} />}
            </div>
        );
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Statistics);
